import { render, staticRenderFns } from "./AccountUsers.vue?vue&type=template&id=127a86a4&scoped=true"
import script from "./AccountUsers.vue?vue&type=script&lang=js"
export * from "./AccountUsers.vue?vue&type=script&lang=js"
import style0 from "./AccountUsers.vue?vue&type=style&index=0&id=127a86a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127a86a4",
  null
  
)

export default component.exports